export interface ComponentBaseConfigModel {
    enabled: boolean;
    title?: string;
}
